import axios from 'axios';
import store from '../store';
import vue from 'vue';
import router from '../router';
import { FedLogOut } from 'store/modules/user';
axios.defaults.withCredentials = true;
import Cookies from "js-cookie";
import user from "../store/modules/user";
import {interceptor} from "./encrypt";
// import router from '../router';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 30000, // 请求超时时间
/*  withCredentials:  true //跨域请求允许带cookie*/
});


// request拦截器
service.interceptors.request.use(async config => {
  // Do something before request is sent
    if(config.method == "get"){
        if(config.url.indexOf("?") >= 0){
            config.url = config.url+"&_t="+new Date().getTime();
        }else {
            config.url = config.url+"?_t="+new Date().getTime();
        }
    }
    // else if(config.url.toString().endsWith('getCompanyshareholder')){
    //   console.log(config.data,'原data')
    //   let data =  config.data;
    //   config.data = await interceptor(data);
    //   console.log( config.data)
    // }
  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
   response => {
        if(response.data == "403"){
            // const url = store.getters.url;
            store.dispatch('FedLogOut').then(() => {
                location.href = process.env.BASE_API+"signin";
                // location.href = url+"/signin";
            })
        }else {
            return response;
        }
    },
  error => {
    console.log('err' + error);// for debug
    vue.$Message.error({
                    message: error.message,
                    duration: 5 * 1000,
                    closable: true
                });
    return Promise.reject(error);
  }
)

export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js